import { type MetaFunction } from 'react-router'
import { pageMeta } from '#app/utils/page-meta.ts'

export const meta: MetaFunction = (args) => pageMeta(args, { title: 'Om oss' })

export default function AboutRoute() {
	return <div>Om oss</div>
}
